import { render, staticRenderFns } from "./TkStarRating.vue?vue&type=template&id=7ab77dc6&"
import script from "./TkStarRating.vue?vue&type=script&lang=js&"
export * from "./TkStarRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports